import { translation } from "./Translation";
import {
  isRtlLanguage,
  normalizeLanguage,
} from "./languages";

export const VISITOR_LANGUAGE_CHANGE_EVENT = "visitor-language-change";

export function t(key, lang) {
  const normalized = normalizeLanguage(lang);
  const entry = translation[key];

  if (!entry) {
    return "";
  }

  return entry[normalized] || entry.fa || entry.en || "";
}

export function applyDocumentLanguage(lang) {
  if (typeof document === "undefined") {
    return normalizeLanguage(lang);
  }

  const normalized = normalizeLanguage(lang);
  const rtl = isRtlLanguage(normalized);

  document.documentElement.lang = normalized;
  document.documentElement.dir = rtl ? "rtl" : "ltr";
  document.body?.classList.toggle("lang-rtl", rtl);
  document.body?.classList.toggle("lang-ltr", !rtl);

  return normalized;
}

export function setVisitorLanguage(lang) {
  const normalized = applyDocumentLanguage(lang);

  if (typeof window !== "undefined") {
    localStorage.setItem("lang", normalized);
    window.dispatchEvent(
      new CustomEvent(VISITOR_LANGUAGE_CHANGE_EVENT, {
        detail: { lang: normalized },
      })
    );
  }

  return normalized;
}

export function getStoredLanguage() {
  if (typeof window === "undefined") {
    return "fa";
  }

  return normalizeLanguage(localStorage.getItem("lang") || "fa");
}
